function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.004 3.034h14.97m-14.97 7.984h14.97m-14.97 7.984h14.97M1.02 1.038h3.992V5.03H1.02zm0 7.984h3.992v3.992H1.02zm0 7.984h3.992v3.992H1.02z",
  stroke: "#000",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22
  }, props), _ref);
}

export default SvgList;